import React, { useEffect } from "react";
import AddonStyle from "./AddonStyle.module.scss";
import { ReactComponent as AdditionalSiteIcon } from "../../../../AdminAssets/svg/VisitsIcon.svg";
import { Grid2 } from "@mui/material";
import InfoRow from "../InfoRow/InfoRow";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
//icons
import { ReactComponent as StagingIcon } from "../../../../AdminAssets/svg/Staging.svg";
import { ReactComponent as PerformanceIcon } from "../../../../AdminAssets/svg/performance.svg";
import { millisecondsToRoundedHours } from "../../../../../../Utils/utils";

function Addon(props) {
  const { invoiceItems, addonData } = props;
  const items = Array.isArray(invoiceItems) ? invoiceItems : [invoiceItems];
  const navigate = useNavigate();
  const { orgId } = useParams();

  const { stagingCredits, usedCreditsTs } = useSelector((state) => ({
    stagingCredits: state.sitesInfo?.credits?.stagingCredits,
    usedCreditsTs: state.sitesInfo?.credits?.usedTs,
  }));

  let timestamp = millisecondsToRoundedHours(usedCreditsTs);

  useEffect(() => {
    const fetchData = () => {
      getStore().dispatch({
        type: Actions.API_STAGING_TIMESTAMP,
        data: {
          orgId: orgId,
          siteId: 0,
        },
        meta: {
          onSuccess: () => {},
          onError: () => {},
        },
      });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 600000);

    return () => clearInterval(intervalId);
  }, [orgId]);
  // Group by licenseType and sum up used and quantity
  const groupedItems = items?.reduce((acc, item) => {
    const licenseType = item?.licenseType || "Unknown";
    if (!acc[licenseType]) {
      acc[licenseType] = {
        licenseType,
        used: 0,
        quantity: 0,
        limitOrAvailablity: 0,
      };
    }
    if (licenseType === "Staging") {
      for (let i = 0; i < item?.featureDetails?.length; i++) {
        if (item.featureDetails[i]?.used !== null) {
          acc[licenseType].used = item.featureDetails[i].used || 0;
          break;
        }
      }
    } else {
      acc[licenseType].used += item?.featureDetails[0]?.used || 0;
    }
    if (licenseType === "Staging") {
      const stagingLimit =
        item?.featureDetails?.find((feature) => feature?.type === "STAGING")
          ?.limitOrAvailablity || 0;
      acc[licenseType].limitOrAvailablity = Math.max(
        acc[licenseType].limitOrAvailablity,
        stagingLimit
      );
    } else {
      acc[licenseType].limitOrAvailablity +=
        item?.featureDetails[0]?.limitOrAvailablity || 0;
    }
    acc[licenseType].quantity += item?.quantity || 0;
    return acc;
  }, {});

  // Convert grouped object to an array for rendering
  const groupedArray = Object.values(groupedItems);

  return (
    <>
      {
        <Grid2 className={AddonStyle.container}>
          <Grid2 className={AddonStyle.heading}>Add-Ons</Grid2>
          {addonData?.length > 0 ? (
            <Grid2 className={AddonStyle.mapItems}>
              {groupedArray.map((group, index) => {
                let Icon;
                switch (true) {
                  case group.licenseType.includes("Additional Site"):
                    Icon = AdditionalSiteIcon;
                    break;
                  case group.licenseType.includes("Performance Sites"):
                    Icon = PerformanceIcon;
                    break;
                  case group.licenseType.includes("Staging"):
                    Icon = StagingIcon;
                    break;
                  default:
                    Icon = null;
                    break;
                }

                return (
                  <Grid2 item key={index}>
                    {Icon && (
                      <InfoRow
                        Icon={Icon}
                        label={group.licenseType || "N/A"}
                        used={timestamp}
                        total={
                          group.licenseType.includes("Staging")
                            ? `${
                                stagingCredits === 0
                                  ? Number(group.limitOrAvailablity)
                                  : Number(group.limitOrAvailablity) +
                                    stagingCredits
                              } hours`
                            : Number(group.quantity) || 0
                        }
                        iconClass={
                          group.licenseType.includes("Staging")
                            ? `${AddonStyle.icon} ${AddonStyle.stagingIcon}`
                            : AddonStyle.icon
                        }
                      />
                    )}
                  </Grid2>
                );
              })}
            </Grid2>
          ) : (
            <Grid2 className={AddonStyle.buyAddons}>
              <CustomButton
                // disabled={!isChecked}
                className={AddonStyle.planButton}
                onClick={() => {
                  navigate(`/account/${orgId}/add-on`);
                }}
              >
                Buy Addons
              </CustomButton>
            </Grid2>
          )}
        </Grid2>
      }
    </>
  );
}

export default Addon;
